export default __webpack_public_path__ + "static/media/img11.494f952f.PNG";